var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CheckTable',{ref:"checkTable",attrs:{"bankId":this.bankId,"productID":this.productID,"zqs":_vm.zqs},on:{"BtnGenClicked":_vm.handleGenBtnClicked}}),_c('loadingTest',{ref:"loadingTest",on:{"complete":_vm.handleLoadingTestComplete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }